"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
function invoiceStatus(invoice) {
  if (invoice) {
    return /* @__PURE__ */ jsxs("span", { className: "load-detail__invoice-status-text", children: [
      "Status: ",
      invoice.status
    ] });
  }
}
function invoiceTitle(props) {
  var text = "Load " + props.load.load.load_id + " auto-confirmed";
  return /* @__PURE__ */ jsx("span", { className: "load-detail__invoice-header-text", children: text });
}
function AutoConfirmedLoadHeader(props) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "load-detail__auto-confirmed-header",
      "data-component": "AutoConfirmedLoadHeader",
      children: [
        /* @__PURE__ */ jsx("h3", { className: "load-detail__invoice-header", children: invoiceTitle(props) }),
        /* @__PURE__ */ jsx("h3", { className: "load-detail__invoice-status", children: invoiceStatus(props.carrierInvoice) })
      ]
    }
  );
}
export default AutoConfirmedLoadHeader;
